import React, { MouseEvent, useState } from 'react';

import CheckboxGroup from './components/checkbox-group/checkbox-group';
import { CheckSolidIcon } from '../../shared/icons/icons';
import Typography from '../typography/typography';

import './checkbox.scss';

interface CheckboxProps {
  ariaLabel?: string;
  ariaLabelledBy?: string;
  className?: string;
  id?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  label?: React.ReactNode;
  name?: string;
  onClick?: (value?: string, event?: MouseEvent) => void;
  value?: string;
}

function Checkbox(props: React.PropsWithChildren<CheckboxProps>) {
  const {
    ariaLabel,
    ariaLabelledBy,
    children,
    className = '',
    id,
    isChecked: isCheckedProp,
    isDisabled,
    label,
    name,
    onClick,
    value
  } = props;
  const [isChecked, setIsChecked] = useState(isCheckedProp || false);
  const isCheckedVal =
    typeof isCheckedProp === 'boolean' ? isCheckedProp : isChecked;

  function handleClick(e) {
    e.preventDefault();
    if (!isDisabled) {
      if (onClick) {
        onClick(value, e);
      }

      if (typeof isCheckedProp !== 'boolean') {
        setIsChecked(!isChecked);
      }
    }
  }

  return (
    <Typography
      className={`checkbox ${className} ${
        isCheckedVal ? 'checkbox--checked' : ''
      }`}
      onClick={handleClick}
      onKeyPress={handleClick}
      role="none"
      styleName="checkbox"
      tag="div"
      variant="P"
    >
      <span className="checkbox__container" styleName="container">
        <input
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          checked={isCheckedVal}
          disabled={isDisabled}
          id={id}
          name={name}
          readOnly
          tabIndex={0}
          type="checkbox"
          value={value}
        />

        <span
          className="checkbox__icon"
          styleName={`box ${isCheckedVal ? 'display-checked' : 'display'} ${
            isDisabled ? 'checkbox-disabled' : ''
          }`}
        >
          <CheckSolidIcon />
        </span>
      </span>
      {label && (
        <label
          data-testid="checkbox_label"
          htmlFor={id}
          styleName={`label ${isDisabled ? 'label-disabled' : ''}`}
        >
          {label}
        </label>
      )}
      {children}
    </Typography>
  );
}

export { CheckboxGroup };
export default Checkbox;
